"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDisplayDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const types_1 = require("../../../types");
const approximate_daily_impressions_1 = require("./commons/approximate-daily-impressions");
const display_opacity_schedule_1 = require("./commons/display-opacity-schedule");
const display_schedule_1 = require("./commons/display-schedule");
const display_widget_1 = require("./commons/display-widget");
const create_display_dto_1 = require("./create-display.dto");
// --- 4. DTO PRINCIPAL ACTUALIZADO ---
class UpdateDisplayDto {
    display_id;
    owner;
    name;
    audio;
    availability_range;
    // --- NUEVO CAMPO PRICING ---
    // Transformación robusta: Permite recibirlo como Objeto JSON o como String JSON (desde FormData)
    pricing;
    autoaccept_media;
    category;
    description;
    ad_policies;
    display_tech_info;
    external;
    interior;
    restricted_access;
    restricted_send;
    platform_provider;
    tags;
    exclusions;
    medias;
    token;
    url_streetview;
    address;
    address_details;
    clearAddressDetails;
    widget;
    schedule;
    opacity_schedule;
    display_time_zone;
    provider;
    send_restriction;
    standard_price;
    metadata;
    screensaver_url;
    screensaver_duration;
    standard_currency;
    private_only;
    /** @deprecated Use audience_stats daily totals. */
    approximateDailyImpressions;
    audience_stats;
    media_types;
    internal_blacklist;
    show_qr_to_send_content;
    show_display_qr;
    show_media_qr;
    published;
    files;
    visible;
    is_archived;
}
exports.UpdateDisplayDto = UpdateDisplayDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "display_id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "owner", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "audio", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_display_dto_1.AvailabilityRangeDto),
    __metadata("design:type", create_display_dto_1.AvailabilityRangeDto)
], UpdateDisplayDto.prototype, "availability_range", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => {
        if (value === undefined)
            return undefined;
        if (!value)
            return null;
        if (typeof value === "string") {
            try {
                return JSON.parse(value);
            }
            catch {
                return value; // Deja que el validador falle si no es JSON válido
            }
        }
        return value;
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)((o) => !!o.pricing),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_display_dto_1.DisplayPricingDto),
    __metadata("design:type", Object)
], UpdateDisplayDto.prototype, "pricing", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "autoaccept_media", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_display_dto_1.AdPoliciesDto),
    (0, class_validator_1.ValidateIf)((o) => !!o.ad_policies),
    __metadata("design:type", create_display_dto_1.AdPoliciesDto)
], UpdateDisplayDto.prototype, "ad_policies", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "display_tech_info", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "external", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "interior", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "restricted_access", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "restricted_send", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "platform_provider", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], UpdateDisplayDto.prototype, "tags", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsIn)(types_1.DISPLAY_EXCLUSIONS, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], UpdateDisplayDto.prototype, "exclusions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeNestedObjectArrayInput)(value, true)),
    (0, class_validator_1.IsArray)({ message: "Medias debe ser un array" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_display_dto_1.MediaItemDto),
    (0, class_validator_1.ValidateIf)((o) => !!o?.medias?.length),
    __metadata("design:type", Array)
], UpdateDisplayDto.prototype, "medias", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "token", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "url_streetview", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeNestedClassInput)(value, create_display_dto_1.DisplayAddressDetailsDto)),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_display_dto_1.DisplayAddressDetailsDto),
    __metadata("design:type", create_display_dto_1.DisplayAddressDetailsDto)
], UpdateDisplayDto.prototype, "address_details", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => value === true || value === "true"),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "clearAddressDetails", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => display_widget_1.Widget),
    __metadata("design:type", display_widget_1.Widget)
], UpdateDisplayDto.prototype, "widget", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Transform)(({ value }) => typeof value === "object" ? value : typeof value === "string" ? JSON.parse(value) : {}),
    (0, class_transformer_1.Type)(() => display_schedule_1.DisplayScheduleDto),
    __metadata("design:type", display_schedule_1.DisplayScheduleDto)
], UpdateDisplayDto.prototype, "schedule", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Transform)(({ value }) => typeof value === "object" ? value : typeof value === "string" ? JSON.parse(value) : {}),
    (0, class_transformer_1.Type)(() => display_opacity_schedule_1.DisplayOpacityScheduleDto),
    __metadata("design:type", display_opacity_schedule_1.DisplayOpacityScheduleDto)
], UpdateDisplayDto.prototype, "opacity_schedule", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "display_time_zone", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : value)),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "provider", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : value)),
    (0, class_validator_1.ValidateIf)((o) => !!o.send_restriction),
    (0, class_validator_1.IsIn)(["only-list", "none"], {
        message: "send_restriction must be one of: only-list, none",
    }),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "send_restriction", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], UpdateDisplayDto.prototype, "standard_price", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeNestedObjectInput)(value)),
    __metadata("design:type", Function)
], UpdateDisplayDto.prototype, "metadata", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "screensaver_url", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], UpdateDisplayDto.prototype, "screensaver_duration", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateDisplayDto.prototype, "standard_currency", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "private_only", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (value === "null" ? null : value)),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => approximate_daily_impressions_1.ApproximateDailyImpressions)
    /** @deprecated Use audience_stats daily totals. */
    ,
    __metadata("design:type", Object)
], UpdateDisplayDto.prototype, "approximateDailyImpressions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeNestedClassArrayInput)(value, create_display_dto_1.AudienceStatInputDto)),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_display_dto_1.AudienceStatInputDto),
    (0, class_validator_1.ValidateIf)((o) => !!o?.audience_stats?.length),
    __metadata("design:type", Array)
], UpdateDisplayDto.prototype, "audience_stats", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], UpdateDisplayDto.prototype, "media_types", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_transformer_1.Transform)(({ value }) => (0, create_display_dto_1.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], UpdateDisplayDto.prototype, "internal_blacklist", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "show_qr_to_send_content", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "show_display_qr", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "show_media_qr", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "published", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], UpdateDisplayDto.prototype, "files", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "visible", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], UpdateDisplayDto.prototype, "is_archived", void 0);
